export const fieldMarkers = Object.freeze({
    SEARCH_TYPE: 'SEARCH_TYPE',
    LISTING_STATUS_FILTER: 'LISTING_STATUS_FILTER',
    LISTING_TYPE: 'LISTING_TYPE',
    DATE: 'DATE',
    OWNER: 'OWNER',
    OFFICE: 'OFFICE',
    AM_BREAKDOWN_TAB: 'BREAKDOWN_TAB',
    FROM_OR_TO: 'FROM_OR_TO',
    AGENT_NAME: 'AGENT_NAME',
    TAB_LABEL: 'TAB_LABEL',
    PERIOD: 'PERIOD',
    MLS_NAME: 'MLS_NAME',
});

export const exportButtonTypes = {
    primary: 'primary',
    secondary: 'secondary',
};
